import Grid from "@mui/material/Grid2";
import React from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { ui } from "../../../../../../../../interfaces/interfaces";
import TabPanel from "../../../../../../../Shared/TabPanel";
import useDebugInformation from "../../../../../../../../hooks/useDebugInformation";
import DirectDebitForm from "./DirectDebitForm";
import StripeForm from "./StripeForm";
import { useAppSelector } from "@store/hooks";

const name = "CarePaymentDetails"

const handleChange = (event: React.SyntheticEvent<Element, Event>, value: number) => {
  ui.CarePlanPaymentActiveSideTab = value
};

const a11yProps = (index: number) => {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

type Props = {
  parent: string
}

const CarePaymentDetails: React.FC<Props> = ({ parent }) => {
  const serviceAgreementPaymentTab = useAppSelector(({ ui }) => ui.CarePlanPaymentActiveSideTab)
  const serviceAgreementBillingPaymentTypes = useAppSelector(({ ui }) => ui.CarePlanBillingMethodPaymentType)

  const debugName = `${parent}▷[${name}]`

  useDebugInformation(debugName, { serviceAgreementPaymentTab })
  return (
    <Grid container >
      <Tabs
        orientation="vertical"
        variant="standard"
        value={serviceAgreementPaymentTab}
        onChange={handleChange}
        aria-label="Vertical tabs for Service Agreement Payment"
        sx={{ borderRight: 1, borderColor: 'divider', button: { maxWidth: 75, minWidth: 75 } }}>
        <Tab label={serviceAgreementBillingPaymentTypes?.serviceAgreementPaymentTypeId === 1 ? "Direct Debit" : "Card Payment"} {...a11yProps(0)} wrapped />
      </Tabs>
      <TabPanel parent={debugName} value={serviceAgreementPaymentTab} index={0} style={{ marginBottom: 12, minHeight: 345 }} >
        {serviceAgreementBillingPaymentTypes?.serviceAgreementPaymentTypeId === 1 ? <DirectDebitForm prefix="CarePlanPaymentBankDetails" parent={debugName} /> : <StripeForm />}
      </TabPanel>
    </Grid>
  );
};

CarePaymentDetails.displayName = name

export default React.memo(CarePaymentDetails);
